import axios from 'axios';

// Define a URL base da API dinamicamente
const BASE_API =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://127.0.0.1:8000/api' // URL para ambiente local
    : 'https://mercadinhointeligente.com.br/api'; // URL para ambiente de produção

const BASE_URL =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://127.0.0.1:8000' // URL para ambiente local
    : 'https://mercadinhointeligente.com.br'; // URL para ambiente de produção

  sessionStorage.setItem('BASE_URL', JSON.stringify(BASE_URL)); // Armazenando todos os dados
      

console.log('Base API:', BASE_API); // Apenas para conferir qual URL está sendo usada

// Configura uma instância do Axios com opções padrão
const api = axios.create({
  baseURL: BASE_API,
  timeout: 10000, // 10 segundos de timeout
  headers: {
    'Content-Type': 'application/json',
  },
});


const pagBankApi = axios.create({
  baseURL: '',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});


export const verificarCheckout = async (dadosCheckin) => {

  const endpoint = '/pedido/verificarSeClientePodeFazerCheckout';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  // console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dadosCheckin);
    return response.data; // Retorna a resposta do backend, que será true ou false
  } catch (error) {
    console.error('Erro ao fazer verificar o checkout: ', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
}

export const verificarSeCheckinEstaAtivoNaBase = async (dadosCheckin) => {

  const endpoint = '/auth/verificarSeCheckinEstaAtivoNaBase';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  // console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dadosCheckin);
    return response.data; // Retorna a resposta do backend, que será true ou false
  } catch (error) {
    console.error('Erro ao fazer verificar o checkin na base: ', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
}






// função de checkout pagbank
export const criarCheckoutPagBank = async (pedidos, cpfClienteCheckin) => {
  console.log('Entrou no criarCheckoutPagbank do Api.js...');
  console.log('cpf do cliente: ');
  console.log(cpfClienteCheckin);

  pedidos['cpfClienteCheckin'] = cpfClienteCheckin;
  
  // vamos incluir no array de pedidos, o cpf do cliente que está pagamento a conta
  const pedidosAtualizados = pedidos.map((pedido) => {
    return { ...pedido, cpfClienteCheckin };
  });
  // atualizar o valor de pedidos
  pedidos = pedidosAtualizados;
  
  console.log('Pedidos:::');
  console.log(pedidos);

  const endpoint = '/pedido/criarCheckoutPagbank';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, pedidos);
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao fazer checkout pagbank:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
}


/**
 * função que cria um pagamento no pagbank gerando token do cartão do cliente.
 * Esse token será usado para compras futuras com um só clique
 */
export const criarPagamentoPagBankGerandoToken = async (pedidos, userData) => {
  console.log('Entrou no criarPagamentoPagBankGerandoToken do Api.js...');

  const dados = {
    pedidos: pedidos,
    userData: userData
  };

  console.log('userData:');
  console.log(userData);

  console.log('Pedidos:::');
  console.log(pedidos);

  const endpoint = '/pagbank/criarPagamentoPagBankGerandoToken';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao fazer checkout pagbank:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
}


// função que verifica se os checkouts pagbank foram concretizados
export const verificarCheckoutsPagBank = async () => {
  console.log('Entrou no verificarCheckoutsPagBank do Api.js...');

  const endpoint = '/pedido/verificarCheckoutsPagBank';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint);
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao verificar os checkouts pagbank:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
}


export const backup = async () => {
  try {
    const token = '08eccdbb-e17c-4204-9c76-eaf9e494492e867c3aec4266a96aa0d3591bdfde8b090389-8b20-4c72-bb1e-d058e57705e8';
    const response = await pagBankApi.post('https://sandbox.api.pagseguro.com/checkouts', 
      {
        "reference_id": 1,
       
        "customer": {
          "name": "Márcio Vascs",
          "email": "mvascs@gmail.com"
        },
        "items": [
          {
            "reference_id": 1,
            "name": "Produto 1",
            "quantity": 1,
            "unit_amount": 100,
            "image_url": "https://www.petz.com.br/blog//wp-content/upload/2018/09/tamanho-de-cachorro-pet-1.jpg"
          }
        ],
        "payment_methods": [
          {
            "type": "credit_card"
          }
        ],
        "payment_methods_configs": [
          {
            "type": "credit_card",
            "config_options": [
              {
                "option": "installments_limit",
                "value": "1"
              }
            ]
          }
        ],
        "soft_descriptor": "Conta",
        "redirect_url": "https://barinteligente.com.br",
        "return_url": "https://barinteligente.com.br",
        "notification_urls": [
          "https://barinteligente.com.br"
        ],
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${token}`,
          'Content-type': 'application/json',
          accept: '*/*',
          'x-api-header': 'sandbox'
        }

      }
     
      
     );

    console.log(response.data);
    // Redirecione o usuário para a URL de checkout
    window.open(response.data.checkoutUrl, '_blank');
  } catch (error) {
    console.error(error);
  }
};

// Função para quitar uma conta
export const quitarConta = async (dados) => {
  console.log('Entrou no quitarConta do Api.js...');
  console.log('Dados que serão enviados:', dados);

  const endpoint = '/pedido/quitarConta';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao quitar a conta:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para cadastrar produto estabelecimento
export const cadastrarProdutosEstabelecimento = async (dados) => {
  console.log('Entrou no cadastrarEstabelecimento do Api.js...');
  console.log('Dados que serão enviados:', dados);

  const endpoint = '/produto/cadastrarProdutosEstabelecimento';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao cadastrar os Produtos:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para forçar checkout de um determinado checkin
export const forcarCheckoutCheckin = async (dados) => {
  console.log('Entrou no forcarCheckoutChedin do Api.js...');
  console.log('Dados que serão enviados:', dados);

  const endpoint = '/contas/forcarCheckoutCheckin';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao forçar checkout:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para cadastrar um funcionario
export const cadastrarPedido = async (dados) => {
  console.log('Entrou no cadastrarPedido do Api.js...');
  console.log('Dados que serão enviados:', dados);

  const endpoint = '/pedido/cadastrarPedido';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao cadastrar o Pedido:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para cadastrar um funcionario
export const comprarFichas = async (dados) => {
  console.log('Entrou no comprarFichas do Api.js...');
  console.log('Dados que serão enviados:', dados);

  const endpoint = '/pedido/comprarFichas';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao comprar fichas:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para atualizar produtos do estabelecimento
export const atualizarProdutosEstabelecimento = async (dados) => {
  console.log('Entrou no atualizarEstabelecimento do Api.js...');
  console.log('Dados que serão enviados:', dados);

  const endpoint = '/produto/atualizarProdutosEstabelecimento';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao cadastrar os Produtos:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para atualizar dados do checkin pelo qrcode da mesa
export const atualizarDadosCheckinComQrCodeMesa = async (dados, numeroMesa) => {
  console.log('Entrou no atualizarDadosCheckinComQrCodeMesa do Api.js...');
  console.log('Dados que serão enviados:', dados, numeroMesa);

  // Adiciona o número da mesa aos dados
  dados = {
    ...dados,
    numeroMesa: numeroMesa,
  };

  const endpoint = '/auth/atualizarDadosCheckinComQrCodeMesa';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao atualizar o checkin:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para cadastrar um funcionario
export const cadastrarFuncionario = async (dadosFuncionario) => {
    console.log('Entrou no cadastrarFuncionario do Api.js...');
    console.log('Dados enviados:', dadosFuncionario);
  
    const endpoint = '/user/cadastrarfuncionario';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, dadosFuncionario);
      return response.data; // Retorna a resposta do backend
    } catch (error) {
      console.error('Erro ao cadastrar Funcionario:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };

// Função para cadastrar um funcionario
export const excluirFuncionario = async (dadosFuncionario) => {
    console.log('Entrou no excluirFuncionario do Api.js...');
    console.log('Dados enviados:', dadosFuncionario);
  
    const endpoint = '/user/excluirfuncionario';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, dadosFuncionario);
      return response.data; // Retorna a resposta do backend
    } catch (error) {
      console.error('Erro ao cadastrar Funcionario:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };

  

// Função para cadastrar outro produto que não está nos produtos do mercadinho
export const cadastrarOutrosProdutos = async (dados) => {
  console.log('Entrou no cadastrarOutrosProdutos do Api.js...');
  console.log('Dados enviados:', dados);

  const endpoint = '/produto/cadastrarOutrosProdutos';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    // const response = await api.post(endpoint, dados);
    const response = await axios.post(fullUrl, dados, {
      headers: {
        'Content-Type': 'multipart/form-data',
        // 'Authorization': `Bearer ${userData.token}`,  // Certifique-se de que o token está sendo enviado
      },
    });
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao cadastrar Produto:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};


// Função para cadastrar um gerente
export const cadastrarGerente = async (dadosGerente) => {
    console.log('Entrou no cadastrarGerente do Api.js...');
    console.log('Dados enviados:', dadosGerente);
  
    const endpoint = '/user/cadastrargerente';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, dadosGerente);
      return response.data; // Retorna a resposta do backend
    } catch (error) {
      console.error('Erro ao cadastrar gerente:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };
  
// Função para informar pagamento de conta
export const informarPagamentoConta = async (produtos) => {
    console.log('Entrou no informarPagamentoConta do Api.js...');
    console.log('Dados enviados:', produtos);
  
    const endpoint = '/cliente/informarPagamentoConta';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, produtos);
      return response.data; // Retorna a resposta do backend
    } catch (error) {
      console.error('Erro ao informar pagamento de conta:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };
  
  // função que busca a conta do cliente pela mesa ou pela comanda
  export const getContaCliente = async (userData, dadosCliente) => {
    console.log('Entrou em getContaCliente em api.js...');
    console.log(dadosCliente);
    console.log(userData);

    const dados = {
      userData,
      dadosCliente
    };

    console.log('Dados que serão enviados:');
    console.log(dados);

    const endpoint = '/cliente/getContaCliente';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, dados);
      return response.data; // Retorna a resposta do backend
    } catch (error) {
      console.error('Erro ao receber a conta do cliente:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }

  }

  // Função para cadastrar um cliente
  export const cadastrarCliente = async (dadosCliente, cartaoCriptografado) => {

    console.log('Entrou no cadastrarCliente do Api.js...');
    console.log('Dados enviados:', dadosCliente);
    console.log('cartão criptografado: ');
    console.log(cartaoCriptografado);

    dadosCliente['cartaoCriptografado'] = cartaoCriptografado;

    console.log('Dados cliente com cartão');
    console.log('Dados enviados:', dadosCliente);

  
    const endpoint = '/cliente/cadastrarcliente';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, dadosCliente);
      return response.data; // Retorna a resposta do backend
    } catch (error) {
      console.error('Erro ao cadastrar cliente:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };
  
  // Função para recuperar a chave pública do pagbank
  export const getChavePublica = async () => {

    console.log('Entrou no getChavePublica do Api.js...');
    
    const endpoint = '/cliente/getChavePublicaPagbank';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint);
      return response.data; // Retorna a resposta do backend
    } catch (error) {
      console.error('Erro ao recuperar a chave pública:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };
  
// Função para buscar dados do estabelecimento
export const buscarDadosEstabelecimento = async (userData) => {
    console.log('Entrou no buscarDadosEstabelecimento do Api.js...');
    console.log('Dados enviados:', userData);
  
    const endpoint = '/estabelecimento/buscarDadosEstabelecimento';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, userData);

      console.log('retorno: ');
      console.log(response.data);

      return response.data; // Retorna a resposta do backend
      
    } catch (error) {
      console.error('Erro ao buscar dados do Estabelecimento:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };

// Função para buscar os produtos do mercadinho - todos
export const buscarProdutosMercadinho = async (dados) => {
  console.log('Entrou no buscarProdutosMercadinho do Api.js...');
  console.log('Dados enviados:', dados);

  const endpoint = '/estabelecimento/buscarProdutosMercadinho';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno: ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar produtos:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para buscar os checkins que possuem contas em aberto
export const buscarCheckinsComContasEmAberto = async (dados) => {

  console.log('Entrou no buscarCheckinsComContasEmAberto do Api.js...');
  console.log('Dados enviados:', dados);

  const endpoint = '/contas/buscarCheckinsAbertos';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno: ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar produtos:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para buscar as mesas que possuem contas em aberto
export const buscarMesasAbertas = async (dados) => {

  console.log('Entrou no buscarMesasAbertas do Api.js...');
  console.log('Dados enviados:', dados);

  const endpoint = '/contas/buscarMesasAbertas';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno: ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar produtos:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para buscar produtos do estabelecimento
export const buscarProdutosEstabelecimento = async (dados) => {
  console.log('Entrou no buscarProdutosEstabelecimento do Api.js...');
  console.log('Dados enviados:', dados);

  const endpoint = '/estabelecimento/buscarProdutosEstabelecimento';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno (produtos do estab.): ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar produtos:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para buscar produtos do estabelecimento
export const buscarPedidos = async (dados) => {
  console.log('=================');
  console.log('Entrou no buscarPedidos do Api.js...');
  console.log('Dados enviados:', dados);

  
  const endpoint = '/pedido/buscarPedidos';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno (pedidos): ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar pedidos:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};



// Função para buscar produtos do estabelecimento
export const buscarMeusPedidosEmAndamento = async (dados) => {
  console.log('=================');
  console.log('Entrou no buscarMeusPedidosEmAndamento do Api.js...');
  console.log('Dados enviados:', dados);

  
  const endpoint = '/pedido/buscarMeusPedidosEmAndamento';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno (pedidos): ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar pedidos:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para buscar fichas do cliente, que não foram utilizadas
export const buscarFichasPendentesDePagamento = async (dados) => {
  console.log('=================');
  console.log('Entrou no buscarFichasPendentesDePagamento do Api.js...');
  console.log('Dados enviados:', dados);

  
  const endpoint = '/ficha/buscarFichasPendentesDePagamento';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno (fichas): ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar fichas:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para buscar fichas do cliente, que não foram utilizadas
export const buscarFichasPagas = async (dados) => {
  console.log('=================');
  console.log('Entrou no buscarFichasPagas do Api.js...');
  console.log('Dados enviados:', dados);

  
  const endpoint = '/ficha/buscarFichasPagas';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno (fichas): ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar fichas pagas:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para buscar produtos do estabelecimento
export const buscarMeusPedidosEntregues = async (dados) => {
  console.log('=================');
  console.log('Entrou no buscarMeusPedidosEntregues do Api.js...');
  console.log('Dados enviados:', dados);

  
  const endpoint = '/pedido/buscarMeusPedidosEntregues';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno (pedidos): ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar pedidos:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para buscar fichas já utilizadas
export const buscarMinhasFichasUtilizadas = async (dados) => {
  console.log('=================');
  console.log('Entrou no buscarMinhasFichasUtilizadas do Api.js...');
  console.log('Dados enviados:', dados);

  
  const endpoint = '/ficha/buscarMinhasFichasUtilizadas';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno (fichas): ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar fichas:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para buscar produtos do estabelecimento
export const buscarPedidosEntreguesNaMesa = async (dados) => {
  console.log('=================');
  console.log('Entrou no buscarPedidosEntreguesNaMesa do Api.js...');
  console.log('Dados enviados:', dados);

  
  const endpoint = '/pedido/buscarPedidosEntreguesNaMesa';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno (pedidos): ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar pedidos:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para buscar produtos do estabelecimento
export const buscarProdutosEstabelecimentoParaCardapio = async (dados) => {
  console.log('Entrou no buscarProdutosEstabelecimentoParaCardapio do Api.js...');
  console.log('Dados enviados:', dados);

  const endpoint = '/estabelecimento/buscarProdutosEstabelecimentoParaCardapio';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);

    console.log('retorno (produtos do estab.): ');
    console.log(response.data);

    return response.data; // Retorna a resposta do backend
    
  } catch (error) {
    console.error('Erro ao buscar produtos:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para buscar funcionários do estabelecimento
export const buscarFuncionariosDoEstabelecimento = async (userData) => {
    console.log('Entrou no buscarFuncionariosDoEstabelecimento do Api.js...');
    console.log('Dados enviados:', userData);
  
    const endpoint = '/estabelecimento/buscarFuncionariosDoEstabelecimento';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, userData);

      console.log('retorno: ');
      console.log(response.data);

      return response.data; // Retorna a resposta do backend
      
    } catch (error) {
      console.error('Erro ao buscar funcionários do Estabelecimento:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };

  // Função para buscar categorias dos produtos do mercadinho
export const buscarCategoriasDeProdutos = async (userData) => {
    console.log('Entrou no buscarCategoriasDeProdutos em Api.js...');
    console.log('Dados enviados:', userData);
  
    const endpoint = '/produto/buscarCategoriasDeProdutos';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, userData);

      console.log('retorno: ');
      console.log(response.data);

      return response.data; // Retorna a resposta do backend
      
    } catch (error) {
      console.error('Erro ao buscar categorias de produtos: ', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };

// Função para buscar estabelecimentos
export const buscarEstabelecimentos = async (userData) => {
    console.log('Entrou no buscarEstabelecimentos do Api.js...');
    console.log('Dados enviados:', userData);
    console.log('latitude enviada:', userData.latitude);
    console.log('longitude enviada:', userData.longitude);
  
    const endpoint = '/estabelecimento/buscarEstabelecimentos';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, userData);

      console.log('retorno: ');
      console.log(response.data);

      return response.data; // Retorna a resposta do backend
      
    } catch (error) {
      console.error('Erro ao buscar Estabelecimentos:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };
  
// Função para salvar a edição dos dados do estabelecimento
export const salvarEdicaoDadosEstabelecimento = async (userData, formData) => {
  console.log('Entrou no salvarEdicaoDadosEstabelecimento do Api.js...');
  console.log('Dados que serão enviados:', formData);

  // Verifica o conteúdo do FormData
  formData.forEach((value, key) => {
    console.log(key, value);
  });

  const endpoint = '/estabelecimento/salvarEdicaoDadosEstabelecimento';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await axios.post(fullUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${userData.token}`,  // Certifique-se de que o token está sendo enviado
      },
    });

    console.log('Retorno:', response.data);
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao salvar os dados do Estabelecimento:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para salvar a edição dos dados do estabelecimento
export const darAndamentoAoPedido = async (userData, idPedido, idProdutoEstabelecimento) => {

  console.log('Entrou no darAndamentoAoPedido do Api.js...');
  console.log('Dados que serão enviados:', userData, idPedido, idProdutoEstabelecimento);


  const endpoint = '/pedido/darAndamentoAoPedido';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {

    const dados = {
      userData: userData,
      idPedido: idPedido,
      idProdutoEstabelecimento: idProdutoEstabelecimento
    };

    
    const response = await axios.post(fullUrl, dados, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${userData.token}`,  // Certifique-se de que o token está sendo enviado
      },
    });

    console.log('Retorno:', response.data);
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao dar andamento ao pedido:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};

// Função para enviar as fichas - enviar as fichas para o bar ou para a cozinha
export const enviarFichas = async (fichas) => {
  console.log('Entrou no enviarFichas do Api.js...');
  console.log('Dados que serão enviados:', fichas);

  const endpoint = '/ficha/enviarFichas';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, fichas);
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao enviar as fichas:', error.response || error.message);
    throw error; // Lança o erro para ser tratado no componente
  }
};
  
// Função para efetuar o login
export const efetuarLogin = async (dados) => {
    console.log('Entrou no efetuarLogin do Api.js...');
    console.log('Dados enviados:', dados);
  
    const endpoint = '/auth/loginBarInteligente';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, dados);
      return response.data; // Retorna a resposta do backend
    } catch (error) {
      console.error('Erro ao efetuar login:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };
  
// Função para fazer checkin
export const fazerCheckin = async (dados) => {
  console.log('---- Entrou no fazerCheckin do Api.js ---');
  console.log('Dados recebidos:', dados);

  const endpoint = '/auth/fazerCheckinBarInteligente';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`;
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao fazer checkin:', error.response || error.message);
    throw error;
  }
};

// Função para fazer checkout
export const fazerCheckout = async (dados) => {
  console.log('Entrou no fazerCheckou do Api.js...');
  console.log('Dados recebidos:', dados);

  const endpoint = '/auth/fazerCheckoutBarInteligente';
  const fullUrl = `${api.defaults.baseURL}${endpoint}`;
  console.log('URL completa da requisição:', fullUrl);

  try {
    const response = await api.post(endpoint, dados);
    return response.data; // Retorna a resposta do backend
  } catch (error) {
    console.error('Erro ao fazer checkout:', error.response || error.message);
    throw error;
  }
};

// Exporta o Axios para uso genérico, se necessário
export default api;
